"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOfferLimitsAndShoppingBagItems = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _utils = require("../../../utils");
/**
 * Hook that computes the remaining amount and quantity for the offer and return them with selected offer items of the offer.
 */
const useGetOfferLimitsAndShoppingBagItems = ({
  offer,
  selectedOfferItems
}) => {
  const {
    maxAmountToSpend,
    maxQuantityToBuy,
    selectedItemsTotalAmount
  } = offer;
  const {
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    maxProductQuantity
  } = shoppingContext?.shoppingBag ?? {
    maxProductQuantity: 99,
    offers: []
  };
  const remainingAmount = (0, _react.useMemo)(() => (0, _utils.getRemainingAmount)({
    maxAmountToSpend,
    selectedItemsTotalAmount
  }), [maxAmountToSpend, selectedItemsTotalAmount]);
  const totalSelectedQuantity = (0, _react.useMemo)(() => (0, _utils.getTotalSelectedQuantity)(selectedOfferItems), [selectedOfferItems]);
  const remainingQuantity = (0, _react.useMemo)(() => (0, _utils.getRemainingQuantity)({
    maxProductQuantity,
    maxQuantityToBuy,
    totalSelectedQuantity
  }), [maxProductQuantity, maxQuantityToBuy, totalSelectedQuantity]);
  return (0, _react.useMemo)(() => ({
    remainingAmount,
    remainingQuantity
  }), [remainingAmount, remainingQuantity]);
};
exports.useGetOfferLimitsAndShoppingBagItems = useGetOfferLimitsAndShoppingBagItems;